<main class="backgroundstyle">
  <!-- common component -->
  <div *ngIf="showLoginPage">
    <lib-login-page
      [portal]="'MEMBER'"
      [constants]="constants"
      [subHeading]="subHeadingText"
      [loginEndPoint]="'/auth/signin'"
      [forgotPasswordEndpoint]="'/auth/forgotPassword'"
      [activationCodeEndpoint]="'/auth/userActivation/'"
      [resetPasswordEndpoint]="'/member/reset-password'"
      [api]="env"
      [lang]="lang"
      [currClient]="currClient"
    ></lib-login-page>
  </div>
</main>

<!-- Overview -->
<app-overview
  *ngIf="OverviewComponent"
  [customerId]="customerId"
></app-overview>
